var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"justify-center"},[_c('v-col',{attrs:{"cols":"12","md":"8","lg":"6","xl":"5"}},[_c('h1',{staticClass:"mt-12 mb-5"},[_vm._v("Passwort zurücksetzen")]),(_vm.$route.params.token)?_c('reset-password'):_c('request-reset-email')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }